var map = {
	"./amplify-amazon-button_5.entry.js": [
		15695,
		16
	],
	"./amplify-auth-fields_9.entry.js": [
		15696,
		17
	],
	"./amplify-authenticator.entry.js": [
		15697,
		5
	],
	"./amplify-button_3.entry.js": [
		15698,
		18
	],
	"./amplify-chatbot.entry.js": [
		15722,
		4
	],
	"./amplify-checkbox.entry.js": [
		15699,
		19
	],
	"./amplify-confirm-sign-in_7.entry.js": [
		15700,
		6
	],
	"./amplify-container.entry.js": [
		15701,
		20
	],
	"./amplify-federated-buttons_2.entry.js": [
		15702,
		21
	],
	"./amplify-federated-sign-in.entry.js": [
		15703,
		22
	],
	"./amplify-form-field_4.entry.js": [
		15704,
		23
	],
	"./amplify-greetings.entry.js": [
		15705,
		24
	],
	"./amplify-icon-button.entry.js": [
		15706,
		25
	],
	"./amplify-icon.entry.js": [
		15707,
		7
	],
	"./amplify-link.entry.js": [
		15708,
		26
	],
	"./amplify-nav_2.entry.js": [
		15709,
		27
	],
	"./amplify-photo-picker.entry.js": [
		15710,
		28
	],
	"./amplify-picker.entry.js": [
		15711,
		29
	],
	"./amplify-radio-button_2.entry.js": [
		15712,
		8
	],
	"./amplify-s3-album.entry.js": [
		15713,
		9
	],
	"./amplify-s3-image-picker.entry.js": [
		15714,
		10
	],
	"./amplify-s3-image.entry.js": [
		15715,
		11
	],
	"./amplify-s3-text-picker.entry.js": [
		15716,
		12
	],
	"./amplify-s3-text.entry.js": [
		15717,
		13
	],
	"./amplify-select-mfa-type.entry.js": [
		15718,
		30
	],
	"./amplify-sign-in-button.entry.js": [
		15719,
		14
	],
	"./amplify-toast.entry.js": [
		15720,
		31
	],
	"./amplify-tooltip.entry.js": [
		15721,
		32
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 15688;
module.exports = webpackAsyncContext;